import { connect } from 'react-redux';
import { getCreditBrokerStatus } from '@marmalade/account/lib/selectors';

const withCreditBroker = Component => connect(state => getCreditBrokerStatus(state))(Component);

export default withCreditBroker;
